export default __webpack_public_path__ + "static/media/deliveryVisuals.9f3b559b.png";